import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { MarketingLayout } from "./components/marketing/MarketingLayout";

import Home from "./pages/marketing/Home";
import Exams from "./pages/marketing/Exams";
import CTF from "./pages/marketing/CTF";
import Features from "./pages/marketing/Features";
import Security from "./pages/marketing/Security";
import Contact from "./pages/marketing/Contact";
import SimplePage from "./pages/marketing/SimplePage";
import NotFound from "./pages/marketing/NotFound";

export default function App() {
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/exames" element={<Exams />} />
        <Route path="/ctf" element={<CTF />} />
        <Route path="/recursos" element={<Features />} />
        <Route path="/seguranca" element={<Security />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/integracoes" element={<SimplePage pageKey="integrations" />} />
        <Route path="/docs" element={<SimplePage pageKey="docs" />} />
        <Route path="/blog" element={<SimplePage pageKey="blog" />} />
        <Route path="/sobre" element={<SimplePage pageKey="about" />} />
        <Route path="/privacidade" element={<SimplePage pageKey="privacy" />} />
        <Route path="/termos" element={<SimplePage pageKey="terms" />} />
        <Route path="/dpa" element={<SimplePage pageKey="dpa" />} />
      </Route>

      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
